import { useEffect, useState } from "react";
import "./css/AdminBookings.css";
import {API_BASE_URL, BookingGetStatusBookingsAPIEndpoint, BookingapproveBookingEndpoint} from "../constant.js"
import Header from "./Header";
import Loader from "./Loader";
//import { capitalizeFirstLetter } from "../utils/common";


const MyBookings = () => {
  const token = sessionStorage.getItem("JWTtoken");
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [bookingStatus, setBookingStatus] = useState("All");


  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 4; 

const indexOfLast = currentPage * recordsPerPage;
const indexOfFirst = indexOfLast - recordsPerPage;

const currentRecords = bookings.slice(indexOfFirst, indexOfLast);
const totalPages = Math.ceil(bookings.length / recordsPerPage);

const setResidentID = sessionStorage.getItem("residentId");
const userType = sessionStorage.getItem("userType");



  useEffect(() => {
    fetchPendingBookings();
  }, []);

  const fetchPendingBookings = async () => {
    setLoading(true);


    try {
      const bookingAPIURL = API_BASE_URL + BookingGetStatusBookingsAPIEndpoint;
      const res = await fetch(bookingAPIURL, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`,
          }
        });
      const result = await res.json();
      if (result.status) {
        
        if(userType !== "admin"){
                //alert("userType !== admin" + userType !== "admin");
                // Use the JavaScript filter() method to get only active users
                const loggedInUserData = result.data.filter(user => user.resident_id === setResidentID)
                setBookings(loggedInUserData);
            } 
            else{
                setBookings(result.data);
            }
       
      }
      else
      {
        setError(result.message || "Failed to fetch pending bookings");
      }      
    }catch (error) {
      console.error(error);
    }
    setLoading(false);
  };

  const updateStatus = async (data, status) => {
    if (!window.confirm(`Are you sure to ${status} this ${data.name} booking?`)) return;

    
    try {
      const approvalBookingAApiURL = API_BASE_URL + BookingapproveBookingEndpoint;
      const payload = {
          "id":data.id,
          "status":status
        };
      const res = await fetch(approvalBookingAApiURL,
        {
          method: "POST",
          headers: { 
            "Content-Type": "application/json", 
             "Authorization": `Bearer ${token}`,
           },
          body: JSON.stringify(payload)
        }
      );
      const result = await res.json();
      //alert(result.message);
      

      // Remove updated booking from pending list
      //setBookings((prev) => prev.filter((b) => result.id !== id));
      fetchPendingBookings();
    } catch (error) {
      console.error(error);
    }
  };


const GetAll = async(status) =>{
  setLoading(true);
  //const capitalizedName = capitalizeFirstLetter(status);
  if(status == "")
  {
    setBookingStatus("All");
  }
  else
  {
    setBookingStatus(status);
  }
  
  setCurrentPage(1);  
  try {    
      const approvalBookingAApiURL = API_BASE_URL + BookingGetStatusBookingsAPIEndpoint;
      const payload = {
          "status":status
        };
      const res = await fetch(approvalBookingAApiURL,
        {
          method: "POST",
          headers: { 
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`,
           },
          body: JSON.stringify(payload)
        }
      );
      const result = await res.json();

      if (result.status) {
        if(userType !== "admin"){
                //alert("userType !== admin" + userType !== "admin");
                // Use the JavaScript filter() method to get only active users
                const loggedInUserData = result.data.filter(user => user.resident_id === setResidentID)
                setBookings(loggedInUserData);
            } 
            else{
                setBookings(result.data);
            }
      }
      else
      {
        setError(result.message || "Failed to fetch pending bookings");
      }      
    }catch (error) {
      console.error(error);
    }
    setLoading(false);
  };



  return (<>

    
    <Header/>
    <div className="admin-bookings">        
      <h2 style={{ textTransform: 'capitalize' }}>My {bookingStatus} Bookings 
        
                <button
                  className="btn-approve"
                  style={{ float : "right" }}
                  onClick={() => GetAll("rejected")}
                >
                  Rejected
                </button> 
                <button
                  className="btn-approve"
                  style={{ float : "right" }}
                  onClick={() => GetAll("approved")}
                >
                  Approved
                </button> 
                <button
                  className="btn-approve"
                  style={{ float : "right" }}
                  onClick={() => GetAll("pending")}
                >
                  Pending
                </button> 
                <button
                  className="btn-approve"
                  style={{ float : "right" }}
                  onClick={() => GetAll("")}
                >
                  All
                </button> 
                
                
                
      </h2>
        {loading && <Loader />}
      { /*loading && <p>Loading...</p> */}
      <table>
        <thead>
          <tr>
            <th>Area</th>
            <th>Date</th>
            <th>Time</th>
            <th>Resident</th>
            <th>Purpose</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>          
          {
          currentRecords.length > 0 ? (
              currentRecords.map((data) => (
            <tr key={data.id}>
              <td>{data.name}</td>
              <td>{data.booking_date}</td>
              <td>
                {data.start_time} - {data.end_time}
              </td>
              <td>({data.apartment}) -  - {data.ownerName}</td>
              <td>{data.purpose}</td>
              
              
              <td className={userType === "admin" ? "actions" : "" } >
                {( data.status !== "rejected" ) &&  <button                
                  className="btn-reject"
                  onClick={() => updateStatus(data, "rejected")}
                style={{ marginLeft: "6px" }}
                >
                  Reject
                </button>}
              </td>
            </tr>
          ))
          ) : (
            <tr>
              <td colSpan="6" align="center">No records found</td>
            </tr>
          )
          }
        </tbody>
      </table>
<div style={{ marginTop: "10px" }}>
    <button
    onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
    disabled={currentPage === 1}> Prev 
  </button>

  {[...Array(totalPages)].map((_, i) => (
    <button
      key={i}
      onClick={() => setCurrentPage(i + 1)}
      style={{
        fontWeight: currentPage === i + 1 ? "bold" : "normal",
        margin: "0 5px"
      }}
    >
      {i + 1}
    </button>
  ))}

  <button
    onClick={() =>
      setCurrentPage(prev => Math.min(prev + 1, totalPages))
    }
    disabled={currentPage === totalPages}
  >
    Next
  </button> { indexOfFirst + 1} to {bookings.length < indexOfLast ? bookings.length : indexOfLast} of Total Record {bookings.length} 
</div>
    </div>
    </>
  );
};

export default MyBookings;
